/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Row} from "react-bootstrap";
import React from "react";

export const StreamBankListEmptyRow = (props) => {
    const {
        fieldDef
    } = props;
    
    const {
        association,
        title = 'Items',
    } = fieldDef ?? {};
    
    return <Row key="empty-warning" className="pop-row">
        <div className="sb-no-items-warning">
            <span>No {title}
                <span className="sb-print-hide">{association?.customData?.emptySuffix ?? " defined"}</span>.
            </span>
        </div>
    </Row>;
};
